import React from 'react';
import globals from "../globals";

export default function Redes({ nro }) {
    return null;
    const style = {
        color: '#636363',
        fontSize: '40px',
        backgroundColor: 'transparent',
        marginLeft: '10px',
        padding: '0px',
        borderRadius: '20px'
    }
    return (
        <div style={{
            position: 'fixed',
            zIndex: '2001',
            bottom: '15px',
            left: '5px',
            cursor: 'pointer'
        }}>
            <a rel='noreferrer' target='_blank' href={globals.INSTAGRAM}>
                <i className={'fa-brands fa-instagram'}
                   style={{
                       ...style,
                       padding: '0px 0px',
                       borderRadius: '10px'
                   }}
                />
            </a>
            <a rel='noreferrer' target='_blank' href={globals.FACEBOOK}>
                <i className={'fa-brands fa-facebook'} style={style} />
            </a>
        </div>
    )
}
